import { useTranslation } from 'react-i18next';

export const keyPrefix = 'departmentStreamGroupList';
export const useDepartmentStreamGroupListTranslation = () => useTranslation('widgets', { keyPrefix });
export const ruRu = ({
  [keyPrefix]: {
    title: 'Группы источников',
  },
}) as Record<string, unknown>;
export const en = ({
  [keyPrefix]: {
    title: 'Source groups',
  },
}) as Record<string, unknown>;
export const esEs = ({
  [keyPrefix]: {
    title: 'Grupos de flujo',
  },
}) as Record<string, unknown>;
export const ptBr = ({
  [keyPrefix]: {
    title: 'Grupos de fluxo',
  },
}) as Record<string, unknown>;
